import { APP_INITIALIZER, ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppAvailability } from '@awesome-cordova-plugins/app-availability/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { Clipboard } from '@awesome-cordova-plugins/clipboard/ngx';
// import { Contacts } from '@awesome-cordova-plugins/contacts/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { InAppPurchase2 } from '@awesome-cordova-plugins/in-app-purchase-2/ngx';
import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx';
import { Printer } from '@awesome-cordova-plugins/printer/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { WebIntent } from '@awesome-cordova-plugins/web-intent/ngx';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';

import { LazyLoadImageModule } from 'ng-lazyload-image';
import { HttpErrorInterceptor, LoadingInterceptor, TimeoutInterceptor } from './interceptors';

import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';

import { SharedModule } from './shared.module';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmationService, MessageService } from 'primeng/api';

import { IonicStorageModule } from '@ionic/storage-angular'

import { NavComponentModule } from "./components/nav/nav.module";
import { ImpersonationBannerComponent } from './components/impersonation-banner/impersonation-banner.component';

import { StripeService } from './services/stripe.service';
import * as Sentry from "@sentry/angular";

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        BrowserAnimationsModule,
        LazyLoadImageModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        SharedModule,
        IonicStorageModule.forRoot(),
        NavComponentModule,
        TooltipModule,
        InputTextModule,
        ImpersonationBannerComponent
      ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        StatusBar,
        AppAvailability,
        BarcodeScanner,
        Clipboard,
        File,
        FileOpener,
        InAppBrowser,
        InAppPurchase2,
        OneSignal,
        Printer,
        SocialSharing,
        WebIntent,
        Keyboard,
        // First, so it is the outermost: it bounds the whole attempt, and the
        // loading interceptor's finalize still runs when it gives up.
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TimeoutInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true
        }, {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        }, {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => { },
            deps: [Sentry.TraceService],
            multi: true,
        },
        StripeService,
        ConfirmationService,
        MessageService
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
